export const introduction =
  'Nedan följer beskrivning och tips om fanérlimning. [Punkterna 1 - 5 endast utifall existerande fanér först måste avlägsnas].'

export const glue = {
  header: 'Lim',
  body:
    'Limning av fanér kan i beroende av utsatthet ske med såväl kontaktlim som trälim. Nedan anges några lämpliga limtyper för olika användningsområden:',
  usageAreas: [
    'Skyddade lägen (inomhus eller utomhus under tak): Vattenbaserat kontaktlim, alternativt exempelvis Cascol Ute 3337.',
    "Oskyddade lägen: Icke vattenbaserat 'vanligt' kontaktlim, alternativt exempelvis Cascol Marin 3308.",
  ],
  additionalInfo:
    'Notera att såväl kontaktlim som Cascol Marin erfordrar ett högt presstryck under limningsprocessen.',
}

export const fanerRemoval = {
  header: 'Avlägsnandet av befintligt fanér',
  steps: [
    'Dokumentera ådringen.',
    'Hetta upp det gamla fanéret med varmluftspistol eller strykjärn till ca 90 grader (strykjärnet har den fördelen att man enklare kan reglera temperaturen), avlägsna sedan fanéret med hjälp av (vässad) spackelspade, kniv eller stämjärn.',
    'Slipa sedan underlaget jämnt med en långkloss (slippapper fäst på en lång stadig plankbit), först diagonalt, därefter i längsled. Slippappret bör inte vara för fint, utan en viss struktur bör finnas på ytan inför limningen (~ korn 80). Vid större ojämnheter kan ytan först behöva spacklas.',
    'Kontrollera att underlaget är jämnt med ett vattenpass eller genom att rita ett antal streck med blyerts på ytan och därefter slipa längs ytan med långkloss. Är ytan jämn, försvinner samtliga streck under en och samma slipfas.',
    'Är ytan fortfarande är fet (eller om teak), rengör med lösningsmedel (helst aceton i fallet teak)',
  ],
}

export const gluePreparation = {
  header: 'Förberedelser inför limning',
  steps: [
    'Mät ut, märk upp och skär till de fanerbitarna du behöver. Försök att hitta ett mönster på faneret som passar eller överensstämmer med det gamla.',
  ],
  additionalInfo:
    'Skär till bitarna så att både längd och bredd är någon centimeter större än ytan till vilket den skall limmas. Vid skarvning (som endast bör ske i längsled, då det skarven annars synns alltför väl) kan bitarna först med överlapp passas ihop och tejpas med exempelvis maskeringstejp. Därefter markers var skarven skall vara och de sammantejpade bitarna vänds upp och ned. Skarven skärs sedan genom bägge bitarna lämpligen med ett nytt blad försedd mattkniv längs en stållinjal. (Fördelen med att skära fanérbitarna från baksidan är att skäret bildar ett V och att fogen sett från framsidan blir tätare).',
}

export const gluing = {
  header: 'Limning',
  steps: [
    'Maskera först ytor där du inte önskar lim med maskeringstejp.',
    'Fördela lim över fanérarkens baksida och underlag i enlighet med limtillverkarens rekommendationer. Använd ansiktsmask avsedd för organiska ångor ifall kontaktlim används. En fintandad spackelspade kan med fördel användas för fördelningen av lim.',
    '(I fallet kontaktlim) Låt limmet torka rekommenderad tid (ca 10 minuter).',
    'Placera nu fanérarket försiktigt på plats. Försök att stryka eller kavla ut arket från dess mitt ut mot kanterna (jämför tapetsering). Till detta moment kan med fördel en (avkapad) tung brödkavel användas. Var gärna två presoner, då det kan vara svårt att såväl hålla som stryka ut arket. Notera att man i fallet kontaktlim endast har en chans på sig att placera ut arket korrekt, då limmet fäster direkt och det därefter inte går att lyfta och korrigera placeringen.',
    'När limmet är genomhärdat kan eventuella luftbubblor åtgärdas genom att man skär upp bubblan (längs fiberriktningen) och försiktigt för in epoxilim. Har man tillgång till en kanyl är detta mycket enkelt, annars går det också att använda exempelvis nål eller något annat spetsigt föremål. Lägg därefter en tyngd på och låt härda.',
  ],
}

export const postProcessing = {
  header: 'Efterbearbetning',
  steps: [
    'Efter det att limmet är genomhärdat och eventuella bubblor åtgärdade skär man försiktigt bort överflödet med en mattkniv eller fanérsåg.',
  ],
  additionalInfo:
    'I fallet mattkniv: använd gärna ett underlag att skära mot för att inte skära för mycket eller så att fanéret spricker. Då träfibrerna skärs tvärs fiberriktningen, skär utifrån och in för att förhibndra att fanéret flisar sig. Lämna någon millimeters överhäng vid kanter för slipslutbearbetning med långkloss.',
}

export const surfaceTreatment = {
  header: 'Ytbehandling',
  body:
    'Fanérytan kan ytbehandlas i enlighet med vad som är lämpligt för träslaget ifråga. Var dock extra noggrann med ytbehandlingen kanter och hörn, dit annars fukt gärna söker sig. Ifall den fanérade detaljen skall utsättas för väder och vind bör den lackas med en tålig lack som har UV skydd så att den inte gulnar (gärna med ett tvåkomponentlack).',
}
